export default __webpack_public_path__ + "static/media/wall1.4ea3c99a.jpg";